module.exports = __webpack_public_path__ + "static/media/sai.ad03914b.svg";